export default __webpack_public_path__ + "static/media/intro_qanon.aa299b85.jpg";